import { useNavigate, useParams } from "react-router-dom";
import { TransferReceiveForm } from "../features/warehouse/TransferReceiveForm";

// شاشة كاملة لاستلام مناقلة بنقص (تعديل الكميات المستلمة فعلياً).
export default function WarehouseTransferReceivePage() {
  const { tid } = useParams();
  const navigate = useNavigate();
  const back = () => navigate("/warehouse?tab=transfers");
  return <TransferReceiveForm transferId={tid} onClose={back} onDone={back} />;
}
